import React, { useEffect, useRef, useState } from "react";
import "../../styles/components/browse_photographers_page/SpecialityFilter.css";
import { BROWSE_SPECIALITIES } from "../../utils/browseState";

export default function SpecialityFilter({ selectedFilter, setSelectedFilter }) {
  const [showDropdown, setShowDropdown] = useState(false);
  const filterRef = useRef(null);

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (filterRef.current && !filterRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    };

    document.addEventListener("mousedown", handleOutsideClick);
    return () => document.removeEventListener("mousedown", handleOutsideClick);
  }, []);

  const selectFilter = (value) => {
    setSelectedFilter(value);
    setShowDropdown(false);
  };

  return (
    <div className="filter-options" ref={filterRef}>
      <div className="dropdown-wrapper">
        <button
          type="button"
          onClick={() => setShowDropdown((current) => !current)}
          className={`dropdown-button ${showDropdown ? "is-open" : ""}`}
          aria-haspopup="listbox"
          aria-expanded={showDropdown}
        >
          <span className="dropdown-button__copy">
            <span className="dropdown-button__label">Shoot type</span>
            <span className="dropdown-button__value">{selectedFilter || "All"}</span>
          </span>
          <span className="dropdown-button__chevron" aria-hidden="true">⌄</span>
        </button>

        {showDropdown && (
          <div className="dropdown-content" role="listbox" aria-label="Shoot type">
            {["All", ...BROWSE_SPECIALITIES].map((type) => {
              const isSelected = selectedFilter === type;

              return (
                <button
                  type="button"
                  key={type}
                  className={`dropdown-item ${isSelected ? "is-selected" : ""}`}
                  onClick={() => selectFilter(type)}
                  role="option"
                  aria-selected={isSelected}
                >
                  <span className="dropdown-item__indicator" aria-hidden="true">
                    {isSelected ? "✓" : ""}
                  </span>
                  <span>{type}</span>
                </button>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
}
